import type {
  CosmicBannerDataType,
  CosmicProductsBannerType,
} from '@/lib/cms/cosmic/types/CosmicProductsBannerType'
import type { CosmicCategoryResponseType } from '@/lib/cms/cosmic/types/CosmicCategoryType'
import type { CMSError } from '@/lib/cms/types/CMSError'

type BannerDataReturnType =
  | {
      error: CMSError
    }
  | CosmicBannerDataType
  | null

// This function is used to get the banner data for the grid page
// It returns the banner data for the product category if it exists
// Otherwise, it returns the banner data for the products banner image data
// If both are null, it returns null, or a CMSError

export const getGridPageBannerData = (
  productCategoryData: CosmicCategoryResponseType | { error: CMSError } | null,
  productsBannerImageData:
    | CosmicProductsBannerType
    | { error: CMSError }
    | null,
): BannerDataReturnType => {
  if (
    productCategoryData &&
    !('error' in productCategoryData) &&
    'banners' in productCategoryData &&
    productCategoryData.banners.length > 0
  ) {
    return productCategoryData.banners[0] || null
  }

  if (
    productsBannerImageData &&
    !('error' in productsBannerImageData) &&
    'data' in productsBannerImageData &&
    Array.isArray(productsBannerImageData.data.productsBanner)
  ) {
    return productsBannerImageData.data.productsBanner[0]?.data || null
  }

  return productsBannerImageData && 'data' in productsBannerImageData
    ? productsBannerImageData.data.productsBanner[0]?.data || null
    : productsBannerImageData
}
